export const contentDispositionHeaderFilenameRegexp: RegExp = new RegExp(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
